import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../AxiosBaseApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles({
  formContainer: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    margin: "0 20px",
  },
});
export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function unsetCookie() {
  setCookie("token", "", 0);
  setCookie("auth", "", 0);
}

const LoginForm = () => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [countryCode, setCountryCode] = useState("+91"); // Default country code
  const history = useNavigate();
  const [data, setData] = useState({
    username: null,
    password: null,
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    const mamberID = localStorage.getItem("mamberId");
    if (mamberID) {
      history("/");
    }
  }, []);

  const handleNavigation = (path) => {
    history(path);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Create FormData object
    const formData = new FormData();
    formData.append("username", data.username);
    formData.append("password", data.password);
    try {
      const response = await axiosInstance
        .post("/bet.php?action=login", formData)

        .then((res) => {
          if (res.status === 200 && res.data.error === false) {
            localStorage.setItem("mamberId", data.username);
            setTimeout(() => {
              history("/home");
            }, 500);
          } else {
             toast.error(res.data.message);
             history("/home");  // history("/home"); history("/home");
            // alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
      history("/home");// history("/home"); history("/home");
    }
  };

  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
         backgroundColor:"#3d3b6f"
        }}
      >
        <Box
          style={{
            height: "8vh",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 25px",
             backgroundImage:"url(/images/login_cloud.png)"
          }}
        >
          <img
            alt="eeee"
            width={30}
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFKElEQVRoge2Za2wUVRTHf4tSeaRN8YmxJho0AlUEe0QeqZKoiYqoRQRJjGIxxkeCiY9oNOoXm6iJBYMJMQooktiACj4QwQYjUXwdq1Z5iGB9xAQjGFFBsRb9cHbcs9OZ7uzubP3C/8ueOffcmf9/9t65554Lh/D/IgPQ0NCQ1v3qgTOAk4HhQHXW/yfwE/AtsBnoALqDTqpa0sMymQyHl0E2wFhgFnApcHrCPj8A64DngfZyHl7OPzAZuBuYVg4B4BNgvqo+V2zHTCZTsoAFwG0R/h6gExsmP2LDpgcYBhyDDbHRQG1E3zeAaar6d1ISpQg4DHgVuDjkfxt4JktiV4F7DAXOBa4Frg61bQGaVHV7EjKZTIYBSQKzGAJ8Rj7594CLgCmYgELkAfYBa4HZwGnAs65tNLBVRCYnJZVUwECMfL3z3Q5MwiZjqdgOzAGmAr84Tu+ISH1cJ4+kAt4CTnHX5wPzE/YtCFV9HRgF/OHcm0SkOqbLf0gioAX74gS4HthQFMMEUNVdwATnqgHWF+pXSMAo4F533YqN9YpAVTux9STABBG5ta8+hQS0Oftz4I4SuSWGqq4BFjrXQhEZEhffl4DZwJisfQAb9/0CVZ2HrSdgi+2TcbF9CXjU2fdhi1J/YrazrxGRY6OC4gRMAuqy9gFS/OIkhapuAd53ruaouDgBM539InAwJV7FYrGzZ0YFxAlodHZbTEx/YBW5lzdORI4MB0QJqMFS5ADvVoBYIqjqHnKTGeCccEyUgLHOvwP4OX1qRaHD2ePCjVECTnD2V6nTKR7bnF0XbozakXlRZ2OZ40fAEuCbNJnFQUQGAXOBC7AtaoCh4djwPzAGeNBdH42ly/cDXcC8VJlGQEQmAl8DTwBXACNcc5OIzPHxXsAILGU+tY/7P46lvhWBiIwENgHHx4RUA0tF5KrAEQgYSH5evwPL06cATcArrm0x2b10BbDM2duB67IcpgNrXNuKYL8QzIGp5P6qvYBkfwOsxt7MROA4bFitTZO5iAzD5hzY5qZBVX93IatE5EMXMwt4IPgHznKBK0PkAzzm7PHlU+6FM53dFiIfoNXZtZAbQn6Fi/vu+xsOLppeYfgvzJ6YmH3OroKcAF/KOCKm8yBn9xRFLRn8PatiYjy3g5AT4L9G3UTD+4upZiSFv+dfCThkfCffEKfef3kSF5+KwD/Ojip8QcSLCxxfOt/0mM5znb0tJqYc+GLWlTExc5y9H3ICXiKXttZh1YATs9dVwEPYegD29v26kApUdSewO3s5XEQ2ishJACIyWERagMtcl/VewG7gLtd4IZb3dADfY1vKAIuB31LmH6DF2Y1Al4h8AXxHfnVktaqug/wx1QosddcDsPTV70U7yReaKlR1AbAo5K7HcrIAH6tqMBp6TYpm4HLgKWxe7Mdq+SuAG7HFplJvHwBVvQWrgCwJNW0FblBV8c5C1eka4NeUOfZC1AmNiKwEZjhXrarmZQhJTmgqTj4KItJOfh1qZph8gDSOmFKDiNQBL5Ofmz2iqivj+lRiRQ3jZuBTYCdWZYgcryLSiJUvPfnlqnpPXzdP+5QyjGbyazsBxmPbVLBKw53kj3eARdkJHYu0TinjUIN9zaKwDKtyz8D2Hh49wE2q+nSSh1RSwHnED9GRwMMR/teAearalfQhlRSwv4jYDdiQeaHYh1RSwEZsY3JURFs3dqL5AZYWbC71IZUU0I0do74Z8u/FjpJSyWgrvQ60A5dgi9IQLDFsw2pMhwDwL3cBL8Bp13+1AAAAAElFTkSuQmCC"
          />

          <Typography style={{ color: "#000", fontSize: 14 }}></Typography>
        </Box>

        {/* <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        > */}
          {/* <img
            src="/images/login_cloud.png"
            alt="logoss"
            // style={{ borderRadius: "18px", width: "39%" }}
          /> */}
        {/* </Box> */}

        <Box component="form" style={{ backgroundImage:"url(/images/login_cloud.png)", backgroundSize: "contain", // Makes sure the image scales without being distorted
                backgroundRepeat: "no-repeat", // Prevents image repetition
                // backgroundPosition: "center",
               }}  onSubmit={handleSubmit}>
          <div className={classes.formContainer}>
            <Box
              style={{ marginTop:'80px',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{
                  backgroundColor: "#fff",
                  minWidth:'80px',
                  borderRadius: "10px 0 0 10px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none", // Removes the border
                    },
                  },
                }}
              >
                <Select value={countryCode} onChange={handleCountryCodeChange}>
                  <MenuItem value="+91">+91</MenuItem>
                </Select>
              </FormControl>
              <TextField
                style={{
                  width: "250px",
                  backgroundColor: "#fff",
                  borderRadius: "0 10px 10px 0",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none", // Removes the border
                    },
                  },
                  "& input:-webkit-autofill": {
                    WebkitTextFillColor: "#000", // Sets text color to black
                  },
                }}
                name="username"
                id="username"
                onChange={handleChange}
                size="small"
                placeholder="Please enter the phone number"
              />
            </Box>
            <TextField
              fullWidth
              onChange={handleChange}
              name="password"
              type={showPassword ? "text" : "password"} // Toggle password visibility
              id="password"
              sx={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none", // Removes the border
                  },
                },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #fff inset", // Forces white background on autofill
                  WebkitTextFillColor: "#000", // Sets text color to black
                },
              }}
              size="small"
              placeholder="Please enter login Password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <FormControlLabel
              control={<Checkbox defaultChecked  sx={{
                '& .MuiSvgIcon-root': {
                  color: 'white', // Set the checkbox icon color to white
                },
              }} />}
              label="Remember username/password"
            />

            {/* Login and Register Buttons */}

            <Box
              style={{
                display: "flex",
                justifyContent: "center",

                alignItems: "center",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  style={{
                    background: "#f83600",
                    borderRadius: "100px",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    display: "inline-block",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: 2.5,
                    minWidth: "225%",
                    padding: "0 1rem",
                  }}
                >
                  Log in now
                </Button>
              </Box>
                   <ToastContainer />
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  type="button"
                  onClick={() => handleNavigation("/register")}
                  style={{
                    background: "#fff",
                    borderRadius: "100px",
                    color: "#000",
                    cursor: "pointer",
                    display: "inline-block",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: 2.5,
                    minWidth: "130%",
                    padding: "0 1rem",
                  }}
                >
                  No account? Register
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </div>
    </>
  );
};

export default LoginForm;
